import { Car, BadgeDollarSign, Handshake, Wrench } from "lucide-react";
import { STATS, WHY_CHOOSE } from "../../data/content";

const bulletIcons = { Car, BadgeDollarSign, Handshake, Wrench };

export const TrustSection = () => (
  <section className="py-24 sm:py-32 border-b border-zinc-800/60" data-testid="trust-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-zinc-800/60 border border-zinc-800/60 mb-24">
        {STATS.map((s) => (
          <div key={s.label} className="bg-[#050505] p-8 sm:p-10 text-center">
            <div className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-2">{s.value}</div>
            <div className="text-xs sm:text-sm text-zinc-400 uppercase tracking-wider">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-start">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500">Why Choose Us</span>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-none text-white mt-4 mb-6">
            Why Customers Choose<br />Mason's Mobile
          </h2>
          <p className="text-zinc-400 leading-relaxed">
            Vegas heat is brutal on vehicles — and shop prices are brutal on wallets.
            Mason's delivers everything a traditional shop does, at better prices than
            shops, automotive centers, and dealerships — with trust, safety, and
            reliability at the core of every repair.
          </p>
        </div>
        <div className="space-y-8">
          {WHY_CHOOSE.map((item) => {
            const Icon = bulletIcons[item.icon] || Wrench;
            return (
              <div key={item.title} className="flex gap-4">
                <div className="bg-blue-600/10 border border-blue-500/20 rounded-sm p-2 h-fit shrink-0">
                  <Icon className="h-5 w-5 text-blue-500" />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-white mb-1">{item.title}</h3>
                  <p className="text-zinc-400 text-sm leading-relaxed">{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
